export default __webpack_public_path__ + "static/media/small Dark.e3629f9d.png";